<template>
  <div>
    <a-table :columns="columns" :dataSource="data" size="middle" :pagination="pagination" @change="tableChange" :rowClassName="classFun" :loading="loading"></a-table>
  </div>
</template>

<script>
import { http } from '@/utils/http'

export default {
  name: 'DayiHistory',
  data() {
    return {
      columns: [
        {
          title: '编号',
          dataIndex: 'index',
          align: 'center',
          width: 80
        },
        {
          title: '开始时间',
          dataIndex: 'beginTime',
        },
        {
          title: '结束时间',
          dataIndex: 'endTime',
        },
        {
          title: '操作人',
          dataIndex: 'realName',
        },
        {
          title: '状态',
          dataIndex: 'serviceCondition',
        },
        {
          title: '操作内容',
          dataIndex: 'remarks',
        },
      ],
      data: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showQuickJumper: true,
      },
      loading: false
    }
  },
  created() {
    this.getDetail()
  },
  methods: {
    getDetail() {
      let parameter = {
        assetId: this.$route.query.id,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }
      this.loading = true
      http('/asset-info-use/getUseList', 'POST', parameter).then(res => {
        this.loading = false
        if (res.success) {
          let data = res.data
          this.pagination.total = data.total
          data.resultList.forEach((item, i) => {
            item.index = (this.pagination.current - 1) * 10 + i + 1
            item.key = item.id
          })
          this.data = data.resultList
        }
      })
    },
    // 表格行类名方法
    classFun(record) {
      if (record.index % 2 == 0) return 'gray'
    },
    // 表格分页事件
    tableChange(pagination) {
      this.pagination.current = pagination.current
      this.getDetail()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-table-pagination.ant-pagination li {
  margin-left: 14px;
}
/deep/ .gray {
  background: #F7F7F7;
}
/deep/ .ant-table-thead {
  background: #F2F2F2;
}
</style>
